import getWithToken from './base/get-with-token'

const getMapDataSewerZones = getWithToken('/map-data/sewer-zones')

export default getMapDataSewerZones